<template>
    <div class="icon-wrapper">
        <div
            class="icon-wrapper__content"
            tabindex="-1"
        >
            <slot></slot>
        </div>
        <div 
            class="icon-wrapper__icon"
            @click.stop.prevent="$emit('click:icon')">
            <v-icon>
                {{ icon }}
            </v-icon>
        </div>
    </div>
</template>

<script>
    export default {
        name: "IconWrapper",
        props: {
            icon: {
                type: String,
                default: undefined,
            },
        }
    }
</script>

<style scoped>
    .icon-wrapper {
        display: flex;
        flex-direction: row;
        height: 100%;
        width: 100%;
        justify-content: stretch;
    }

    .icon-wrapper__content {
        flex-grow: 1;
    }

    .icon-wrapper__icon {
        display: none;
        flex-grow: 0;
        justify-content: center;
        align-items: center;
        /*background-color: rgba(12, 162, 253, 0.7);*/
        background-color: #aaa;
    }

    .icon-wrapper__icon:hover {
        background-color: rgba(12, 162, 253, 0.7);
        /*background-color: #888;*/
        cursor: pointer;
    }

    .form-table__td:hover .icon-wrapper__icon,
    .form-table__td:focus-within .icon-wrapper__icon{
        display: flex;
    }


    .form-table__body__tr .form-table__body__td .icon-wrapper:focus-within .icon-wrapper__icon {
        display: none;
    }
</style>